import { render, staticRenderFns } from "./totalRegister.vue?vue&type=template&id=64ff5bc4&"
import script from "./totalRegister.vue?vue&type=script&lang=js&"
export * from "./totalRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports